import React from 'react';
import PropTypes from 'prop-types';
import style from './style';
import './datatable.css';

class TableRow extends React.Component {
    checkboxSelected = [];
    constructor(props) {
        super(props);
        this.state = {
            isHovering: false,
            checkboxSelected: this.checkboxSelected,
            selectedRow: {},
        };
    }
    handleMouseHover() {
        this.setState({ isHovering: !this.state.isHovering });
    }
    dropdownButton = (props) => {
        return (
            <button
                type="button"
                role="menuitem"
                className="dropdown-item"
                {...props}
            >
                {props.children}
            </button>
        );
    };
    moveCell = () => {
        return (
            <center style={style.handle}>
                <i className="fa fa-arrows-alt handle"></i>
            </center>
        );
    };

    actionCell = () => {
        var Action = this.props.rowAction;
        var CubeAction = this.props.cubeAction;
        return (
            <center>
                <div className="dropdown" style={style.actionIconContainer}>
                    <span
                        className="dropdown-toggle datatable-actionbar"
                        id="drop4"
                        role="button"
                        data-toggle="dropdown"
                        style={style.actionButton}
                    >
                        <i className="fa fa-bars"></i>
                    </span>

                    <div
                        id="menu1"
                        className="dropdown-menu"
                        role="menu"
                        aria-labelledby="drop4"
                    >
                        <Action
                            row={this.props.row}
                            button={this.dropdownButton}
                        />
                    </div>
                    {this.props.showCubes ? (
                        <span role="button" style={style.actionButton}>
                            <CubeAction row={this.props.row} />
                        </span>
                    ) : (
                        ''
                    )}
                </div>
            </center>
        );
    };
    onClickRow = (row) => {
        if (this.props.onClickRow) {
            this.props.onClickRow(row);
            Array.from(
                document.getElementsByClassName('selectable-data-row')
            ).map((Row) => {
                Row.style = '';
            });
            document.getElementById(
                `${this.props.tableId}_row_${row.id}`
            ).style = 'background-color:#39b2d5;color:white';
        }
    };

    render() {
        const CheckboxAction = this.props.checkboxAction;

        return (
            <tr
                id={`${this.props.tableId}_row_${this.props.row.id}`}
                onClick={this.onClickRow.bind(this, this.props.row)}
                className={this.props.onClickRow ? 'selectable-data-row' : `${this.props.row.className || ''}`}
            >
                {this.props.column.map((columnName, key) => {
                    if ('actions' === columnName) {
                        return <td key={key}>{this.actionCell()}</td>;
                    } else if ('display_order' === columnName) {
                        return <td key={key}>{this.moveCell()}</td>;
                    } else if (this.props.checkboxAction) {
                        return (
                            <td key={key}>
                                <CheckboxAction record={this.props.row} />
                            </td>
                        );
                    } else {
                        let text = this.props.row[columnName];
                        if (this.props.header[columnName].textChange) {
                            text = this.props.header[columnName].textChange(
                                text
                            );
                        }

                        return <td key={key} dangerouslySetInnerHTML={{ __html: text }}  />;
                    }
                })}
            </tr>
        );
    }
}

TableRow.propTypes = {
    row: PropTypes.object.isRequired,
    column: PropTypes.array.isRequired,
    header: PropTypes.object.isRequired,
    rowAction: PropTypes.any,
    handleOnClickCheckbox: PropTypes.func,
    showCubes: PropTypes.any,
    cubeAction: PropTypes.any,
    tableId: PropTypes.any,
    onClickRow: PropTypes.any,
    checkboxAction: PropTypes.any,
};

export default TableRow;
